const homeUrl= 'https://marketplace-v2.buupass.com/marketplace/';
// const flightsUrl='https://itinerary.buupass.com/';
const flightsUrl='https://itinerary.buupass.com/';

//const flightsUrl='https://flights-api.buupass.com/';
const v2P='https://pay-v2.buupass.com/payments/';
const usersApi='https://usermanagementapi.dev.buupass.com/user-management/users/';
const usersApiLogin='https://usermanagementapi.dev.buupass.com/user-management/users/login';
const bannerUrl='https://buupassstatic.blob.core.windows.net/marketplaceapi/banners/';
const navLinks = {
  buses: 'https://beta.buupass.com/',
  trains: 'https://metickets.krc.co.ke/',
  flights: 'https://beta.buupass.com/flights',
  hotels: 'https://beta.buupass.com/hotels',
  account: 'https://beta.buupass.com/account'
};
export const environment = {
  production: false,
  navLinks,
  api_key:'66Shf2aP.owT6xw6QKSWNO9EeQIIlz20JM3nNHul3',
  // Faro collector isn't deployed for dev - keep disabled locally (sample rate 0)
  faroUrl: 'https://faro.buupass.com/collect',
  faroAppName: 'v2.flights.buupass.com',
  faroSessionSampleRate: 0,
  // search
  searchFlights: flightsUrl + 'api/v1/search/flights',
  checkFlights: flightsUrl + 'api/v1/check/flights',
  checkFlightsDev: flightsUrl + 'api/v1/check/flights',
  getAirlines: flightsUrl + 'api/v1/kiwi/carriers',
  saveBooking:flightsUrl + 'api/v1/booking/save',
  // home page
  getCredentials: flightsUrl + 'api/v1/flights/credentials',
  getToken: flightsUrl + 'api/v1/oauth/token',
  getKiwiCities: flightsUrl + 'api/v1/kiwi/locations?search=',
  confirmPayments: flightsUrl + 'api/v1/payment/check/status?booking_id=',
  confirmBooking: flightsUrl + 'api/v1/booking/confirm_payment',
  paymentQuery: 'https://pay.buupass.com/query_status',
  v2confirm: v2P+'c2b/transaction/status/',
  paymentStatusWs: 'wss://payments.dev.buupass.com/ws/transaction/status/',
  retrieveEmail: usersApi+'retrieve/',
  resetPassword: usersApi+'password-reset',
  codePass: usersApi+'code-validate',
  updateCodePass: usersApi+'password-reset/',
  signUp: usersApi+'registration',
  loginUser:usersApi+'login',
  getProfile: usersApi+'profile',
  updateProfile: usersApi+'profile',
  usersApiLogin:usersApiLogin,
  getTrips: homeUrl+'booking/search?search=',

  // Travel Duqa
  apiUrl: flightsUrl,
  getTokenCred: flightsUrl + 'token/',
  getCities: flightsUrl + 'destinations/',
  // Prod Keys
  // itinerary_client_id: 'Qsu_dgNu7oar7VPvRuxLbg',
  // itinerary_client_secret_key: 'VYdRuDHUvureG9eTt3N6cZ-3p_WUniAbLs7NTNDevts',

  mobilebannerUrl: bannerUrl+'mobile_flight_config.json',
  webbannerUrl: bannerUrl+'web_flight_config.json',

  // Dev Keys
  // itinerary_client_id:'6d0ed63fdd65b534b2e0447a8fdb485e',
  // itinerary_client_secret_key: 'ed022f4d042837a1a67b8fa2f904d3171c0bb99d404cc4f83649f802d2d13a03'
  itinerary_client_id: 'Qsu_dgNu7oar7VPvRuxLbg',
  itinerary_client_secret_key: 'VYdRuDHUvureG9eTt3N6cZ-3p_WUniAbLs7NTNDevts',

};
